/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rmf_Banner_LabelInputs */

const en_rmf_banner_label = /** @type {(inputs: Rmf_Banner_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rmf-web`)
};

const fr_rmf_banner_label = /** @type {(inputs: Rmf_Banner_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rmf-web`)
};

const ms_sg2_rmf_banner_label = /** @type {(inputs: Rmf_Banner_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rmf-web`)
};

/**
* | output |
* | --- |
* | "rmf-web" |
*
* @param {Rmf_Banner_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const rmf_banner_label = /** @type {((inputs?: Rmf_Banner_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rmf_Banner_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rmf_banner_label(inputs)
	if (locale === "fr") return fr_rmf_banner_label(inputs)
	return ms_sg2_rmf_banner_label(inputs)
});